module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv_logo_v2.b0c9c806c60be9063ee3ab7ae56418df.png";